module.exports = __webpack_public_path__ + "static/media/exclamation-circle.93b0e952.svg";